/**
 * Визначення типу вкладення листа підтримки по розширенню файлу.
 * Колонок `mime_type`/`original_name` у бекенді немає (рішення: "в назві файлу є розширення"),
 * тому тип визначається тільки на фронті.
 */

const EXT_TO_KIND = {
	jpg: 'image', jpeg: 'image', png: 'image', webp: 'image', gif: 'image', bmp: 'image',
	mp4: 'video', webm: 'video', mov: 'video', avi: 'video', mkv: 'video',
	pdf: 'pdf',
	txt: 'text', log: 'text', csv: 'text',
	doc: 'office', docx: 'office', xls: 'office', xlsx: 'office', ppt: 'office', pptx: 'office',
	zip: 'archive', rar: 'archive', '7z': 'archive', tar: 'archive', gz: 'archive',
	html: 'unsafe', htm: 'unsafe', svg: 'unsafe', xhtml: 'unsafe', xml: 'unsafe',
};

export const KIND_ICONS = {
	image: '🖼',
	video: '🎬',
	pdf: '📄',
	text: '📝',
	office: '📊',
	archive: '🗜',
	unsafe: '⚠️',
	other: '📎',
};

const getExtension = (value) => {
	if (!value) return '';
	const clean = value.split(/[?#]/)[0];
	const match = /\.([a-zA-Z0-9]+)$/.exec(clean);
	return match ? match[1].toLowerCase() : '';
};

/**
 * @param {string} name - назва файлу (поле `name` вкладення)
 * @param {string} [contentUrl] - фолбек, якщо в `name` немає розширення (на диску розширення є завжди)
 * @returns {'image'|'video'|'pdf'|'text'|'office'|'archive'|'unsafe'|'other'}
 */
export const getAttachmentKind = (name, contentUrl) => {
	const ext = getExtension(name) || getExtension(contentUrl);
	return EXT_TO_KIND[ext] || 'other';
};

/** @param {'image'|'video'|'pdf'|'text'|'office'|'archive'|'unsafe'|'other'} kind */
export const canOpenInNewTab = (kind) => kind === 'pdf' || kind === 'text' || kind === 'image' || kind === 'video';

/** Розширення файлу великими літерами для підпису на плитці (`PDF`, `MP4`, `DOCX`); без розширення — `''` */
export const getExtensionLabel = (name, contentUrl) => (getExtension(name) || getExtension(contentUrl)).toUpperCase();

/** @param {?number} bytes @returns {?string} */
export const formatFileSize = (bytes) => {
	if (bytes === null || bytes === undefined) return null;
	if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} КБ`;
	return `${(bytes / (1024 * 1024)).toFixed(1)} МБ`;
};
